import type { IconSvgObject } from './types';

const BalloonIcon: IconSvgObject = [
  ["path", { d: "M12.5 17C14.5 17 18.5 12.5 18.5 8C18.5 4.68629 15.8137 2 12.5 2C9.18629 2 6.5 4.68629 6.5 8C6.5 12.5 10.5 17 12.5 17Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M14.5 8C14.5 6.89543 13.6046 6 12.5 6", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M5.5 22C5.5 20.8954 6.39543 20 7.5 20H9.5C10.4319 20 10.8978 20 11.2654 19.8478C11.7554 19.6448 12.1448 19.2554 12.3478 18.7654C12.5 18.3978 12.5 17.9319 12.5 17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default BalloonIcon;
